import type { BlockCMS, Product } from '@/types'
import type { Settings } from 'react-slick'
import Slider from 'react-slick'
import CarrouselArrowIcon from '../Icon/CarrouselArrowIcon'
import ProductCard from '../ProductCard'

interface ModuleProductListType {
  data: BlockCMS
  order: number
}
const ModuleProductList = ({ data, order }: ModuleProductListType) => {
  const settings: Settings = {
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 4,
    variableWidth: false,
    nextArrow: <CarrouselArrowIcon type='next' />,
    prevArrow: <CarrouselArrowIcon type='prev' />,
  }
  const settingsNonSlider: Settings = {
    swipe: false,
    slidesToShow: 4,
    infinite: false,
    variableWidth: false,
    draggable: false,
    arrows: false,
  }
  return (
    <section
      id={data._id}
      className={`${data?.type} ${data?.hideBot ? '' : 'pb-[20px]'} ${
        'order-[' + (order + 1) + ']'
      } scroll-mt-[158px]`}
    >
      <div className='rounded-lg bg-white py-2'>
        {data?.data?.length > 4 ? (
          <Slider {...settings} className='max-w-screen flex'>
            {data &&
              data?.data.map((item: Product) => (
                <ProductCard product={item} key={item._id} />
              ))}
          </Slider>
        ) : (
          <Slider
            {...settingsNonSlider}
            className='max-w-screen non-slick mr-auto flex px-2'
          >
            {data &&
              data?.data.map((item: Product) => (
                <ProductCard product={item} key={item._id} />
              ))}
          </Slider>
        )}
      </div>
    </section>
  )
}

export default ModuleProductList
